export function getTitle(value) {
  if (value.is_emergency) return 'Emergency appointment'
  if (value.appointment_id && value.appointment_id !== 'new')
    return 'Edit appointment'
  return 'New appointment'
}
